import * as mock from './mock'
import { GetProfileData } from './types'

export const getProfileData: GetProfileData = mock.getProfileData
